import React, {Fragment} from "react";
import {Outlet} from "react-router-dom";
import {helpPagesLinks, subMenuRouting} from "data/constants";
import {SubHeader} from "views/components/SubHeader";
import {Preloader} from "views/components/Preloader/preloader.component";
import {Navigation} from "views/components/Navigation";
import {ContainerWithSidebar, InnerContainer} from "views/components/common";

export const HelpLayout: React.FC = () => {
	const isLoading = false;

	if (isLoading) {
		return <Preloader />;
	}

	return (
		<Fragment>
			<SubHeader links={subMenuRouting} />
			<ContainerWithSidebar>
				<InnerContainer>
					<Navigation links={helpPagesLinks} />
					<Outlet />
				</InnerContainer>

				{/*<Aside breakpoint="tablet" />*/}
			</ContainerWithSidebar>
		</Fragment>
	);
};
